export default {
    getUltimasMensagens: state => state.ultimasMensagens,
    getTemplatesCampanha: state => state.templates_campanha.reverse(),
    getAgendamentos: state => state.agendamentos,
    getUltimosAgendamentos: state => state.ultimosAgendamentos,
    getMensagensErro: state => state.mensagens_erro
}



// WEBPACK FOOTER //
// ./src/store/modules/mensagens/getters.js